import VideoBlock from './VideoBlock';

export default VideoBlock;
